// Minimal, escape-first markdown formatter for pipeline-sandbox help content
// (see docs/PIPELINE_SANDBOX_HELP_SYSTEM.md). Covers exactly what current
// content uses: paragraphs, **bold**, *italic*, `code`, and "- " bullet lists.
// No headers/tables/blockquotes/code-fences/links — confirmed with the backend
// team that no drafted entry needs them today; revisit if one ever does.
import * as Utils from './utils.js';

// Re-exported for existing consumers - canonical implementation lives in
// utils.js (docs/XSS_HARDENING_PLAN.md Tier C).
export function escapeHtml(str) {
    return Utils.escapeHtml(str);
}

function inline(text) {
    return text
        .replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>')
        .replace(/`([^`]+?)`/g, '<code>$1</code>')
        .replace(/\*([^*]+?)\*/g, '<em>$1</em>');
}

export function renderMarkdown(src) {
    if (!src) return '';
    const blocks = escapeHtml(src).split(/\n{2,}/).map(b => b.trim()).filter(Boolean);
    return blocks.map(block => {
        const lines = block.split('\n').map(l => l.trim()).filter(Boolean);
        if (lines.length && lines.every(l => /^[-*]\s+/.test(l))) {
            const items = lines.map(l => `<li>${inline(l.replace(/^[-*]\s+/, ''))}</li>`).join('');
            return `<ul>${items}</ul>`;
        }
        return `<p>${inline(lines.join(' '))}</p>`;
    }).join('');
}
